import React, { createContext } from 'react';



export const SystemContext = createContext(null);